import PreviewContact from '../sections/PreviewContact';
import RSAccordion from './RSAccordion';
import RSFlat from './RSFlat';
import {
  Box
} from '@chakra-ui/react';
import { useState } from 'react';
import PreviewBody from '../sections/PreviewBody';

const Sections = ({myData,props,previews,styles,isDesktop }) => {
  //This is for toggling all of the accordions at once.  currently deprecated.
  const [isAccordion, setIsAccordion] = useState(true);
  const PreviewDisplay = isAccordion ? RSAccordion : RSFlat;
  const style = {...styles.accordion, ...styles.section};
  return (

    <Box sx={{...style}}  padding='0 1rem' >
      <PreviewBody props={props} savedResume={myData} isDesktop={isDesktop[0]} />

    </Box>
  );
};
export default Sections;